const vtexMasterdata = function (e) {
  var n = Object.assign(
      {
        entity_sigla: '',
        seller:
          window.jsnomeLoja || ((window.vtex || {}).vtexid || {}).accountName || window.location.hostname.split('.')[0],
      },
      e,
    ),
    i = {
      masterDataURL: '/' + n.seller + '/dataentities/' + n.entity_sigla,
      init: function (t?) {},
      post: function (e) {
        if (null == e) throw new Error("Can't create todo without data");
        return fetch(i.masterDataURL + '/documents', {
          headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8',
          },
          method: 'POST',
          body: JSON.stringify(e),
        }).then((j) => {
          try {
            if (j.status === 204) {
              return Promise.resolve(true);
            }
            return j.json();
          } catch (e) {
            return Promise.resolve(e);
          }
        });
      },
      update: function (e, n) {
        return fetch(i.masterDataURL + '/documents' + (e ? '/' + e : ''), {
          headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8',
          },
          method: 'PATCH',
          body: JSON.stringify(n),
        }).then((j) => {
          try {
            if (j.status === 204) {
              return Promise.resolve(true);
            }
            return j.json();
          } catch (e) {
            return Promise.resolve(e);
          }
        });
      },
      get: function ({ fields, where, range = '0-100' }: { fields?: string; range?: string; where?: string }) {
        return fetch(
          i.masterDataURL + '/search/?' + (!!fields ? '&_fields=' + fields : '') + (!!where ? '&_where=' + where : ''),
          {
            headers: {
              Accept: 'application/json; charset=utf-8',
              'Content-Type': 'application/json; charset=utf-8',
              'REST-Range': 'resources=' + range,
            },
            method: 'GET',
          },
        ).then((j) => j.json());
      },
      scroll: function ({ fields, size, token = null }: { fields?: string; size?: number; token?: string }) {
        return fetch(
          i.masterDataURL +
            '/scroll/?' +
            (!!size ? '&_size=' + size : '') +
            (!!fields ? '&_fields=' + fields : '') +
            (!!token ? '&_token=' + token : ''),
          {
            headers: {
              Accept: 'application/json; charset=utf-8',
              'Content-Type': 'application/json; charset=utf-8',
            },
            method: 'GET',
          },
        ).then((response) => {
          return new Promise((resolve, reject) => {
            try {
              response.json().then((data) => {
                resolve({
                  data,
                  nextToken: response.headers.get('X-VTEX-MD-TOKEN'),
                });
              });
            } catch (e) {
              reject(e);
            }
          });
        });
      },
      refresh: function () {
        i.init();
      },
    };
  i.init();
  var r = function () {
    return {
      get: i.get,
      scroll: i.scroll,
      post: i.post,
      update: i.update,
      refresh: i.refresh,
    };
  };
  return r();
};

window.storeTheme = window.storeTheme || ({} as StoreTheme);

Object.assign(window.storeTheme, { helpers: Object.assign(window.storeTheme.helpers || {}, { vtexMasterdata }) });

export default {};
